var map = {
	"./arabia.png": "4d67",
	"./australia.png": "388c",
	"./austria.png": "1985",
	"./canada.png": "f1ec",
	"./emirates.png": "03c6",
	"./england.png": "e0da",
	"./england1.png": "2006",
	"./england_bac.png": "5674",
	"./germany.png": "862d",
	"./moldova.png": "ba4e",
	"./newzeeland.png": "5fef",
	"./spain.png": "e13f",
	"./switz.png": "bb15",
	"./usa.png": "f1db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e1";